import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import printerApi from '../../../APIs/printer';
import escConstants from '../../../constants';
import {
  Alert,
  Button,
  Loader,
  NavigateBack,
  SelectDropdown,
  Typography,
} from '../../../designComponents';
import NoPrinterFound from '../../../designComponents/PrinterNotFound';
import { PRINTER_ROUTE } from '../../../routes/routePaths';
import { requestAPI } from '../../../utils';
import { ViewJobContainerStyled } from '../../BrowseJobs/BrowseJobDetails/style';
import { AddPrinterContainerStyled } from './style';

type LabelType = {
  _id: string;
  fullName: string;
  emailAddress: string;
};

type OptionsType = {
  label: string;
  value: string;
};

const AddPrinter = () => {
  const navigate = useNavigate();
  const [selectedPrinter, setSelectedPrinter] = useState('');
  const [isError, setIsError] = useState('');
  const [loading, setLoading] = useState(true);
  const [printerOption, setPrinterOption] = useState<LabelType[]>([]);
  // const root = useRoot();
  const onSelectPrinter = (value: string, _record: any) => {
    setSelectedPrinter(value);
    setIsError('');
  };

  const handleGetPrinter = async () => {
    try {
      // const params = { clientId: root.auth?._id };
      const data = await requestAPI(printerApi.getAllPrinter());
      setPrinterOption(data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetPrinter();
  }, []);

  const options: OptionsType[] = Array.isArray(printerOption)
    ? printerOption.map((data) => ({
      // label: data.fullName,
      label: data.fullName + ' - ' + data.emailAddress,
      value: data._id,
    }))
    : [];

  const handleAssociatePrinter = async (id: string) => {
    try {
      const data = await requestAPI(
        printerApi.associatePrinterWithClient({
          printerId: [id],
        }),
      );

      if (data._id) {
        toast(escConstants.toastMessages.selectedPrinter);
        navigate(PRINTER_ROUTE);
      }
    } catch (error: any) {
      if (typeof error === 'string') {
        setIsError(error);
      }
      if (error.error && typeof error.error === 'string') {
        setIsError(error.error);
      }
      console.error('Error encountered : ', error);
    }
  };

  const availablePrinterCount: boolean =
    Array.isArray(printerOption) && printerOption.length > 0;

  return (
    <ViewJobContainerStyled>
      {' '}
      <div
        style={{
          position: 'sticky',
          top: '60px',
          zIndex: '999',
          paddingTop: '5px',
          background: '#fff',
        }}
      >
        <NavigateBack />
      </div>
      <AddPrinterContainerStyled className="contents">
        {loading ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography>Loading available printers, please wait.</Typography>
            <Loader type="spinner" />
          </div>
        ) : availablePrinterCount ? (
          <>
            <Typography className="title">Please select a printer</Typography>
            <div className="printer-select-wrapper">
              <SelectDropdown
                onSelect={onSelectPrinter}
                selected={selectedPrinter}
                options={options}
                placeholder="Select printer to add to list"
              />
            </div>
            {isError && (
              <Alert
                text={isError}
                type="error"
                style={{ marginTop: -10, marginBottom: 10 }}
              />
            )}
            <Button
              variant="secondary"
              onClick={() => {
                handleAssociatePrinter(selectedPrinter);
              }}
            >
              Continue
            </Button>
          </>
        ) : (
          <div className="noPrinterFound">
            <NoPrinterFound message="No Printer Available!!!" />
          </div>
        )}
      </AddPrinterContainerStyled>
    </ViewJobContainerStyled>
  );
};

export default AddPrinter;
